module.exports = __webpack_public_path__ + "assets/img/3-1.e95955e4.jpg";